import DerivAI from './DerivAI';

export default function App() {
  return <DerivAI />;
}
